import React from 'react';
import { connect } from 'react-redux';

import {
  getOfferAffiliate,
} from '../../reducers/ProductReducers';

const Item = ({ name, link }) => (
  <span className="caps push--left" style={{ borderBottom: '1px solid #839AAD' }}>
    <a
      target="_blank"
      href={link}
      style={{ color: '#839AAD' }}
      >
      {name}
    </a>
  </span>
);

const LinksRibbon = ({ offerAffiliate }) => (
  <div
    className="push--top small-only-push--right"
    style={{ fontSize: '12px', textAlign: 'right' }}>
    { offerAffiliate.isEnabled ?
      <Item
        name={offerAffiliate.text}
        link={offerAffiliate.actionUrl}
      /> :
      null
    }
  </div>
);

const mapStateToProps = ({ product }) => ({
  offerAffiliate: getOfferAffiliate(product),
});

export default connect(mapStateToProps)(LinksRibbon);



// WEBPACK FOOTER //
// ./src/product/views/_layout/LinksRibbon.js